export var LocationPageText;
(function (LocationPageText) {
    LocationPageText["INVALID_SKU"] = "Sorry, an error has occurred. Unable to find a flow for sku: ";
    LocationPageText["DELIVERY_ICON"] = "fas fa-house";
    LocationPageText["DELIVERY_ICON_COLOR"] = "";
    LocationPageText["DELIVERY_MARKDOWN"] = "## Delivery";
    LocationPageText["DELIVER_MODAL_TITLE"] = "Delivery";
    LocationPageText["PICKUP_ICON"] = "fas fa-shopping-bag";
    LocationPageText["PICKUP_ICON_COLOR"] = "";
    LocationPageText["PICKUP_MARKDOWN"] = "## Pick up";
    LocationPageText["PICKUP_MODAL_TITLE"] = "Pick up";
    LocationPageText["SELECT"] = "Select";
})(LocationPageText || (LocationPageText = {}));
export var DeliveryFormText;
(function (DeliveryFormText) {
    DeliveryFormText["REQUIRED_POSTAL_CODE"] = "Postal code is required";
    DeliveryFormText["INVALID_POSTAL_CODE"] = "Please enter a valid postal code";
    DeliveryFormText["DO_NOT_DELIVER"] = "We do not delivery to this area";
})(DeliveryFormText || (DeliveryFormText = {}));
